import { UserManager, WebStorageStateStore } from "oidc-client-ts";


// redirectUri = 'http://localhost:3000/callback';

const config = {
  authority: process.env.REACT_APP_AUTH_URL+"/authserver",
  client_id: process.env.REACT_APP_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_REDIRECT_URI,
  response_type: process.env.REACT_APP_RESPONSE_TYPE || "code",
  scope: process.env.REACT_APP_SCOPE || "read",
  stateStore: new WebStorageStateStore({ store: window.localStorage }),
};

export const userManager = new UserManager(config);


